import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/organisms/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/organisms/Header.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/public/images/Icons/favicon-bigs.png");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/styles/globals.css");
